import React from "react";
import { up } from "styled-breakpoints";
import styled from "styled-components";
import Img from "@images/scroll.svg";
import tw from "twin.macro";

import CustomLink from "@components/link";

const Oval = styled(CustomLink)`
  ${tw`
    relative flex justify-center items-center w-60 h-60 mb-10 bg-orange border-2 border-orange rounded-full
    transition-colors duration-400 focus:outline-none
  `}
  
  &:hover {
    ${tw`bg-orange`}
  }
  
  ${up('lg')} {
    .svg-color {
      stroke: #FFF;
      transition: all .4s;
  
      polyline {
        transform: translateY(-3px);
        transition: transform .4s;
      }
    
      line {
        transform: scaleY(0);
        transition: transform .4s;
      }
    }
    
    &:hover {
      ${tw`bg-white`}
      
      .svg-color {
        stroke: #F06140;
  
        polyline {
          transform: translateY(-.5px);
        }
      
        line {
          transform: scaleY(1);
        }
      }

      span {
        ${tw`bg-orange`}
      }
    }
  }
`;

const Arrow = styled(Img)<{ download: boolean }>`
  ${tw`w-15 transform`}
  ${({ download }) => download ? tw`-translate-y-2` : tw`-rotate-90`}
  
  .svg-color {
    stroke: #FFF;
  }
`;

const Line = tw.span`
  absolute bottom-15 left-1/2 transform -translate-x-1/2 w-15 h-2 bg-white rounded-md 
  transition-colors duration-300
`;

const ButtonOval = ({ href, type, download }: { href: string, type: string, download: boolean }) => (
  <Oval to={href} type={type}>
    <Arrow download={download} />
    {download && <Line/>}
  </Oval>
);

export default ButtonOval;
